exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rc-collapse{border-radius:0 0 3px 3px}.rc-collapse>.rc-collapse-item>.rc-collapse-header{text-transform:uppercase;font-weight:700;line-height:20px;border:none;width:100%;text-indent:0;box-shadow:none;border-radius:0;background-color:hsla(50,53%,92%,0)!important}.rc-collapse>.rc-collapse-item>.rc-collapse-header .arrow{display:inline-block;content:\" \";width:0;height:0;font-size:0;line-height:0;border-top:6px solid transparent;border-bottom:6px solid transparent;border-left:8px solid #00285b;vertical-align:middle;margin-right:8px}.rc-collapse>.rc-collapse-item-active>.rc-collapse-header .arrow{border-left:6px solid transparent;border-right:6px solid transparent;border-top:8px solid #00285b;margin-right:4px}.rc-collapse-content-box>.panel-body{padding:5px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./dist/theme/src/rc-collapse.css
// module id = 759
// module chunks = 0